import React, { useState, useEffect, useRef, forwardRef } from 'react'
import PropTypes from 'prop-types'
import { classNames, iconProps } from '@zambezi/sdk/common'

/**
 * @param {import('./interfaces').HeaderContainerProps} props
 * @param {import('react').RefObject} ref
 * @returns {JSX.Element}
 */
function headerContainer (props, ref) {
  const { header: Header, onToggle, ...rest } = props
  const [open, setOpen] = useState(props.open)
  const headerElementRef = useRef()
  useEffect(componentWillReceiveProps, [props.open])
  const containerProps = {
    ...rest,
    className: classNames(
      'zb-accordion-header',
      {
        'zb-accordion-is-active': open
      },
      props.className
    ),
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    open,
    'aria-expanded': open,
    'aria-controls': props['aria-controls'],
    ref
  }

  return <Header {...containerProps} />

  function componentWillReceiveProps () {
    setOpen(props.open)
  }

  function handleClick (e) {
    e && e.preventDefault()

    toggle()
  }

  function handleKeyDown (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      toggle()
      e.preventDefault()
    }

    props.onKeyDown(e)
  }

  function toggle () {
    setOpen(open => !open)
    onToggle && onToggle(headerElementRef.current, !open)
  }
}

const HeaderContainer = forwardRef(headerContainer)

HeaderContainer.displayName = 'HeaderContainer'
HeaderContainer.defaultProps = {
  onKeyDown: () => {}
}
HeaderContainer.propTypes = {
  children: PropTypes.node,
  onToggle: PropTypes.func,
  className: PropTypes.string,
  open: PropTypes.bool,
  onKeyDown: PropTypes.func,
  'aria-controls': PropTypes.string,
  header: PropTypes.elementType,
  iconProps
}

export default HeaderContainer
